import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetConfigurationHistoryEventsResData } from "./GetConfigurationHistoryEventsResData";

const ENDPOINT = "/caosconfiguration/history";

export class GetConfigurationHistoryEventsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetConfigurationHistoryEventsReqData = null;

    constructor(params) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetConfigurationHistoryEventsResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetConfigurationHistoryEventsResData(res);
    }
}

export class GetConfigurationHistoryEventsReqData {
    installationName: string;
    numOfEvents: number;

    constructor(installationName: string, numOfEvents: number) {
        this.installationName = installationName;
        this.numOfEvents = numOfEvents;
    }
}
